"use client";
import { ToasterProvider as HubbleToastProvider } from "@hubble/web";

export function ToasterProvider({ children }: { children: React.ReactNode }) {
  return <HubbleToastProvider>{children}</HubbleToastProvider>;
}
